import Image from "next/image";
import { useTranslation } from "react-i18next";
import arrowRight from "@/assets/images/icons/arrow-right.svg";
import arrowBack from "@/assets/images/icons/arrowBack.svg";
import HexagonButton from "@/common/customElements/HexagonButton";
import { SemiBoldText } from "@/common/texts";
import {
  NEUTRO_PARAGRAPHS_COLOR,
  PRIMARY_BUTTON_COLOR,
} from "@/utils/constants";

interface NavigationItemsProps {
  previousPage: string;
  actualPage: string;
  actionToDo?: () => void;
}

const NavigationItems: React.FC<NavigationItemsProps> = ({
  previousPage,
  actualPage,
  actionToDo,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <HexagonButton
        //onClick={actionToDo ? actionToDo() : window.history.back()}
        width="40px"
        backgroundColor={PRIMARY_BUTTON_COLOR}
        onClick={() => {
          actionToDo ? actionToDo() : window.history.back();
        }}
      >
        <Image
          width={24}
          height={24}
          alt="arrowBack"
          src={arrowBack.src}
          style={{
            cursor: "pointer",
            marginTop: "-29px",
            marginLeft: "8px",
            position: "absolute",
            zIndex: "99",
          }}
        />
      </HexagonButton>
      <SemiBoldText
        style={{ marginTop: "3px" }}
        color={NEUTRO_PARAGRAPHS_COLOR}
      >
        {t(previousPage)}
      </SemiBoldText>
      <Image width={14} height={14} alt="arrowRight" src={arrowRight.src} />
      <SemiBoldText style={{ marginTop: "3px" }}>{t(actualPage)}</SemiBoldText>
    </>
  );
};

export default NavigationItems;
